export default __webpack_public_path__ + "static/media/ticketbanner1.74fa6dd8.jpg";